export default __webpack_public_path__ + "media/images/help_128-823706ecb57134944b81b5581e4753c8.png";